import {MutationTree} from "vuex";
import {IState} from "@/apps/StudyInspiratorWidget/models/store-state-model";
import {IConfig} from "@/apps/StudyInspiratorWidget/models/config";
import {IQuestion} from "@/apps/StudyInspiratorWidget/models/question";
import {IDictionary} from "@/shared/models/interface/dictionary-model";
import {IResult} from "@/apps/StudyInspiratorWidget/models/result";

export default <MutationTree<IState>>{
    setConfig(state, config: IConfig) {
        state.config = config;
    },

    navigateToView(state, component: string) {
        state.currentComponent = component;
    },

    goToStart(state) {
        state.currentComponent = "StartComponent";
    },

    goToQuestions(state) {
        state.currentComponent = "QuestionComponent";
    },

    goToResults(state) {
        state.currentComponent = "ResultComponent";
    },

    toggleExplanation(state) {
        state.explanationActive = !state.explanationActive;
    },

    // Question actions
    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setQuestions(state, questions: IQuestion[]) {
        state.questions = questions;
    },

    setAnswers(state, answers: IDictionary<boolean>) {
        state.answers = answers;
    },

    setResults(state, results: IDictionary<IResult[]>) {
        state.results = results;
    },

    setCurrentIndex(state, index) {
        state.currentIndex = index;
    },

    moveForwards(state) {
        state.currentIndex++;
    },

    moveBackwards(state) {
        state.currentIndex--;
    }
}
